"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewCountStyles = void 0;
exports.viewCountStyles = {
    root: {
        position: "absolute",
        padding: "0.2rem 0.8rem",
        color: "#fff",
        display: "flex",
        gap: "0.7rem",
        justifyContent: "space-between",
        alignItems: "center",
        background: "rgba(29, 29, 29, 0.4)",
        backdropFilter: "blur(3.40008px)",
        border: "1px solid #fff",
        borderRadius: "1.36px",
        bottom: 5,
        right: 5,
    },
    eyeIcon: { width: "15px", marginRight: "3px", height: "11px" },
};
//# sourceMappingURL=styles.js.map